import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

class InternalChatSettings extends Component {
  render() {
    return (
      <section>
        <p>InternalChatSettings</p>
      </section>
    );
  }
}

InternalChatSettings.propTypes = {};

export default translate(InternalChatSettings);
